import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@workos-inc/authkit-react';
import { DEFAULT_PROFILE_PATH, PROFILE_ME_PATH } from '../../lib/profileNav';
import { isOrgAdmin } from '../../lib/permissions';

// The /profile index target. Overview is an administration surface whose stats a plain
// member cannot read, so only an admin is sent there; everyone else lands on the one
// profile page that is theirs.
export function ProfileIndexRedirect() {
  const { permissions } = useAuth();
  // The query string rides along so a product's ?from= survives the hop.
  const { search } = useLocation();
  return <Navigate to={{ pathname: isOrgAdmin(permissions) ? DEFAULT_PROFILE_PATH : PROFILE_ME_PATH, search }} replace />;
}
